import { createContext, useContext, useState, useEffect, useRef } from 'react';

const PricePlanContext = createContext();

export const PricePlanProvider = ({ children }) => {
  const [selectedPlan, setSelectedPlan] = useState({
    name: '',
    duration: '',
    price: '',
    term: ''
  });

  const [pricingData, setPricingData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchInProgress = useRef(false);

  const updateSelectedPlan = (plan) => {
    setSelectedPlan(plan);
  };

  // Fetch pricing data once on mount
  useEffect(() => {
    if (fetchInProgress.current) return;
    
    fetchInProgress.current = true;
    setIsLoading(true);

    fetch(`${process.env.REACT_APP_API_URI}/v3/rates/calculate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ranges: [
          { term: 'special', min: 1, max: 6, unit: 'day' },
          { term: 'short-term', min: 1, max: 3, unit: 'week' },
          { term: 'mid-term', min: 1, max: 11, unit: 'month' },
          { term: 'long-term', min: 1, max: 2, unit: 'year' },
        ]
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success' && data.data) {
          setPricingData(data.data);
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching pricing:', error);
        setIsLoading(false);
      });
  }, []);

  return (
    <PricePlanContext.Provider value={{ 
      selectedPlan, 
      updateSelectedPlan,
      pricingData,
      isLoading
    }}>
      {children}
    </PricePlanContext.Provider>
  );
};

export const usePricePlan = () => {
  const context = useContext(PricePlanContext);
  if (!context) {
    throw new Error('usePricePlan must be used within a PricePlanProvider');
  }
  return context;
}; 